// Brand-priority disclosure banner.
//
// Rendered on the recommendation surface when the resolved tenant has
// `brand_priority_active = true` (i.e. `recommendation_rules.privilege_brand`
// is set in its YAML, with the ADR-0007 post_init forcing
// `disclosure_required` to true). Hidden completely for tenants without a
// privileged brand — ICS-TEST-01 stays visually identical to pre-Layer-C2c.
//
// Briefing Regola 6 + D.Lgs. 219/2006: the user must be informed of the
// commercial relationship before reading a recommendation that may have
// been reranked toward the tenant's own brand. Non-dismissable by design
// — a dismiss button would defeat the regulatory purpose.

import { useBranding } from "@/lib/branding";

export function BrandPriorityDisclosure() {
  const { brandPriorityActive, brandDisclosureText } = useBranding();
  if (!brandPriorityActive || !brandDisclosureText) return null;
  return (
    <section
      role="note"
      aria-label="Trasparenza sulla raccomandazione"
      className="mx-6 mt-4 mb-3 rounded-xl border border-rame/30 bg-rame/10 px-4 py-3 text-[12.5px] leading-[1.55] text-ink"
    >
      <p className="m-0 font-mono text-[10.5px] uppercase tracking-[0.8px] text-rame mb-1.5">
        Trasparenza
      </p>
      <p className="m-0">{brandDisclosureText}</p>
    </section>
  );
}
